

















































































import authType from '@/store/types/auth';
import { TeipNotifications } from '@/util/teipNotifications';
import { mapActions } from 'vuex';
import { AxiosError } from 'axios';
import Vue from 'vue';

export default Vue.extend({
  name: 'Login',
  data: () => ({
    user: {
      email: '',
      password: '',
    },
    loading: false,
  }),
  methods: {
    ...mapActions({
      authenticate: `authModule/${authType.actions.AUTHORIZE}`,
    }),
    async login(): Promise<void> {
      try {
        this.loading = true;

        await this.authenticate(this.user);
        if (process.env.VUE_APP_WS_HOST) {
          // const company = await fetch('http://localhost:3000');

          // window.localStorage.setItem(
          //   'company-translations',
          //   JSON.stringify(await company.json())
          // );
        }

        await this.$router.push({
          name: 'home',
        });
        // window.location.reload(); // for update the items of the i18n getting from localStorage
      } catch (err) {
        const teipNotification = new TeipNotifications();
        const e = err as AxiosError;
        if (e.message.includes('locked_account_by_attempts')) {
          teipNotification.warning('Cuenta Bloqueada');
        } else {
          teipNotification.warning('Correo o Contraseña inválida.');
        }
      }
      this.loading = false;
    },
  },
});
